import axios from 'axios'
import { getUserToken, saveUserToken } from '@/services/tokenService'
import { getLanguage } from '@/config/axios/axiosHelpers'
import { constants } from '@/config/axios/constants'
import { customRouter } from '@/customRouter'

async function getRefreshToken () {
  try {
    return await mvcRequest.get(constants.refreshToken)
  } catch (e) {}

  return null
}

function logoutUser () {
  mvcRequest.post('user/logout')
    .finally(() => {
      window.location.reload()
    })
}

const apiRequest = axios.create({
  baseURL: constants.apiUrl,
  withCredentials: false,
  headers: {
    Accept: 'application/json, text/javascript, */*; q=0.01',
    'Content-Type': 'application/json',
    language: getLanguage() || '1',
    Pragma: 'no-cache'
  }
})

const mvcRequest = axios.create({
  baseURL: constants.mvcRoute,
  withCredentials: false,
  headers: {
    Accept: 'application/json, text/javascript, */*; q=0.01',
    'Content-Type': 'application/json',
    language: getLanguage() || '1',
    Pragma: 'no-cache'
  }
})

const origamiRequest = axios.create({
  baseURL: constants.origamiRoute,
  withCredentials: false,
  headers: {
    Accept: 'application/json, text/javascript, */*; q=0.01',
    'Content-Type': 'application/json',
    language: getLanguage() || '1',
    Pragma: 'no-cache'
  }
})

mvcRequest.interceptors.request.use(
  async config => {
    // console.log(config)
    if (!customRouter.isPublicRoute() && !config.withCredentials) { // doesn't work when added but user is not authorized, so we wrap it in this condition
      config.headers.authorization = getUserToken()
    }
    return config
  },
  error => {
    Promise.reject(error)
  })

// Request interceptor for API calls
apiRequest.interceptors.request.use(
  async config => {
    // console.log(config)
    if (!customRouter.isPublicRoute() && !config.withCredentials) { // doesn't work when added but user is not authorized, so we wrap it in this condition
      config.headers.authorization = getUserToken()
    }
    return config
  },
  error => {
    Promise.reject(error)
  })

origamiRequest.interceptors.request.use(
  async config => {
    // console.log(config)
    if (config.withCredentials) { // doesn't work when added but user is not authorized, so we wrap it in this condition
      config.headers.authorization = getUserToken()
    }
    return config
  },
  error => {
    Promise.reject(error)
  })

// Response interceptor for API calls
apiRequest.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config
  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true

    const userToken = await getRefreshToken()
    if (userToken) {
      axios.defaults.headers.authorization = userToken.data.response
      saveUserToken(userToken.data.response)
      return apiRequest(originalRequest)
    } else {
      logoutUser()
    }
  }

  // if it's a second retry, we will logout user
  if (originalRequest._retry) {
    logoutUser()
  }
  return Promise.reject(error)
})

mvcRequest.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config
  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true

    const userToken = await getRefreshToken()
    if (userToken) {
      axios.defaults.headers.authorization = userToken.data.response
      saveUserToken(userToken.data.response)
      return mvcRequest(originalRequest)
    } else {
      logoutUser()
    }
  }

  // if it's a second retry, we will logout user
  if (originalRequest._retry) {
    logoutUser()
  }
  return Promise.reject(error)
})

export { apiRequest, mvcRequest, origamiRequest }
